import { ReactNode, useMemo } from "react";
import { useLocation } from "react-router-dom";
import Navigation from "../../components/NavigationBar/NavigationBar";
import { routes } from "../../routes/routesConfig";
import {
  AppContainer,
  BleedBackgroundHost,
  MainContent,
} from "./AppLayout.styles";

interface AppLayoutProps {
  children: ReactNode;
}

const HIDE_NAVIGATION_ROUTES = [
  "/",
  "/login",
  "/register",
  "/forgot-password",
  "/reset-password",
];

const isRouteMatched = (pathname: string): boolean => {
  const sortedRoutes = [...routes].sort((a, b) => {
    if (a.path === pathname && b.path !== pathname) return -1;
    if (b.path === pathname && a.path !== pathname) return 1;
    return b.path.length - a.path.length;
  });

  const route = sortedRoutes.find((r) => {
    if (r.path === pathname) return true;

    if (r.path.includes(":")) {
      const basePath = r.path.split(":")[0];
      return pathname.startsWith(basePath);
    }

    return pathname.startsWith(r.path + "/");
  });

  return !!route;
};

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const { pathname } = useLocation();

  const isQuizRoute = pathname.startsWith("/quiz");
  const is404Page = !isRouteMatched(pathname);

  const { shouldHideNavigation } = useMemo(() => {
    const shouldHideNavigationBase =
      HIDE_NAVIGATION_ROUTES.includes(pathname) || isQuizRoute || is404Page;

    return {
      shouldHideNavigation: shouldHideNavigationBase,
    };
  }, [pathname, isQuizRoute, is404Page]);

  return (
    <AppContainer>
      <BleedBackgroundHost id="bleed-bg-host" />
      {!shouldHideNavigation && <Navigation />}
      <MainContent>{children}</MainContent>
    </AppContainer>
  );
};

export default AppLayout;
